<template>
  <div class="container">
    <nav class="nav-menu">
      <ul class="links">
        <li v-for="link in links" :key="link.name">
          <a :href="link.href" target="_blank" rel="noopener noreferrer">{{
            link.name
          }}</a>
        </li>
      </ul>
      <ul class="links -right">
        <li v-for="link in linksRight" :key="link.name">
          <a :href="link.href" target="_blank" rel="noopener noreferrer">{{
            link.name
          }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { name: 'HOME', href: 'https://royalhoney.company/' },
        { name: '新規会員登録', href: 'https://royalhoney.company/register' },
        { name: 'マイページ', href: 'https://royalhoney.company/mypage#' },
        { name: 'ログイン', href: 'https://royalhoney.company/login' },
        { name: '商品一覧', href: 'https://royalhoney.company/products' }
      ],
      linksRight: [
        { name: 'お客様の声', href: 'https://royalhoney.company/testimonials' },
        { name: 'お問い合わせ', href: 'https://royalhoney.company/contact' },
        {
          name: '支払い方法',
          href: 'https://royalhoney.company/about-payment'
        },
        { name: '配送・送料', href: 'https://royalhoney.company/ship-policy' },
        {
          name: '返品・交換',
          href: 'https://royalhoney.company/returnedpolicy'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ccb35f;
  padding: 16px 0;
  position: absolute;
  top: 64px;
}

.nav-menu {
  display: flex;
  width: 50%;
}

.links {
  width: 100%;
  font-size: 0.75em;

  &.-right {
    margin-left: 40px;
  }

  li {
    padding: 12px 0;
  }

  a {
    color: white;
    text-decoration: none;
  }
}
</style>
